var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowsquareright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: props.fill
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.002 8.502a.8.8 0 011.132 0l3.177 3.178a.797.797 0 010 1.14l-3.177 3.178a.8.8 0 11-1.132-1.132l1.817-1.816H8.25a.8.8 0 010-1.6h5.569l-1.817-1.816a.8.8 0 010-1.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M19.5 3.2c.856 0 1.55.694 1.55 1.55v15a1.55 1.55 0 01-1.55 1.55h-15a1.55 1.55 0 01-1.55-1.55v-15c0-.856.694-1.55 1.55-1.55zm-.05 1.6H4.55v14.9h14.9z",
    fillRule: "evenodd"
  }))));
}

export default SvgArrowsquareright;